import React, { useEffect, useState, useRef } from 'react';
import { AnimatePresence } from 'framer-motion';
import { LandingPage } from './components/LandingPage';
import { PresentationView } from './components/PresentationView';
import { AccessModal } from './components/AccessModal';
import { RequestAccessModal } from './components/RequestAccessModal';
// Initialize access log console utilities
import './utils/accessLog';
type ViewState = 'landing' | 'authenticated';
export function App() {
  const [currentView, setCurrentView] = useState<ViewState>('landing');
  const [isAccessModalOpen, setIsAccessModalOpen] = useState(false);
  const [isRequestModalOpen, setIsRequestModalOpen] = useState(false);
  const presentationRef = useRef<HTMLDivElement>(null);
  // State to pass pre-filled data between modals
  const [tempAuthData, setTempAuthData] = useState({
    name: '',
    email: ''
  });
  const isAuthenticated = currentView === 'authenticated';
  // Check auth on mount
  useEffect(() => {
    const wasAuthenticated = localStorage.getItem('dop_authenticated') === 'true';
    if (wasAuthenticated) {
      setCurrentView('authenticated');
    }
  }, []);
  const scrollToPresentation = () => {
    presentationRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const handleSkip = () => {
    if (isAuthenticated) {
      scrollToPresentation();
    } else {
      setIsAccessModalOpen(true);
    }
  };
  const handleLearnMore = () => {
    setIsAccessModalOpen(true);
  };
  const handleAuthenticated = () => {
    setIsAccessModalOpen(false);
    setCurrentView('authenticated');
    // Scroll to presentation after a brief delay for the view to render
    setTimeout(() => {
      scrollToPresentation();
    }, 600);
  };
  const handleRequestAccess = (name: string, email: string) => {
    setTempAuthData({
      name,
      email
    });
    setIsAccessModalOpen(false);
    setTimeout(() => {
      setIsRequestModalOpen(true);
    }, 300);
  };
  const handleBackToLogin = () => {
    setIsRequestModalOpen(false);
    setTimeout(() => {
      setIsAccessModalOpen(true);
    }, 300);
  };
  const handleLogout = () => {
    localStorage.removeItem('dop_authenticated');
    localStorage.removeItem('dop_user_name');
    localStorage.removeItem('dop_user_email');
    setCurrentView('landing');
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-obsidian text-offwhite selection:bg-offwhite/20 selection:text-offwhite" data-id="element-0">
      {/* Video section — always visible at the top */}
      <LandingPage onSkip={handleSkip} onLearnMore={handleLearnMore} isAuthenticated={isAuthenticated} data-id="element-1" />

      {/* Presentation section — rendered below video when authenticated */}
      {isAuthenticated && <div ref={presentationRef} data-id="element-2">
          <PresentationView onLogout={handleLogout} data-id="element-3" />
        </div>}

      <AccessModal isOpen={isAccessModalOpen} onClose={() => setIsAccessModalOpen(false)} onAuthenticated={handleAuthenticated} onRequestAccess={handleRequestAccess} data-id="element-4" />

      <RequestAccessModal isOpen={isRequestModalOpen} onClose={() => setIsRequestModalOpen(false)} onBack={handleBackToLogin} prefillName={tempAuthData.name} prefillEmail={tempAuthData.email} data-id="element-5" />
    </div>;
}